import { SanityImageSource } from '@sanity/asset-utils'
import Link from 'next/link'

import ImageComponent from './ImageComponent'

interface Props {
  link: string
  title: string
  description: string
  icon?: SanityImageSource
  showDescriptionOnHover?: boolean
}

export function LinkCard({
  link,
  title,
  description,
  icon,
  showDescriptionOnHover,
}: Props) {
  const maybeUrl = link
  return (
    <>
      {maybeUrl ? (
        <Link
          href={maybeUrl}
          className={`group relative col-span-12 flex grow h-full justify-between gap-2 rounded-lg border border-green-200 bg-green-50 p-5 pr-20 md:col-span-6 hover:shadow-l ${showDescriptionOnHover && `items-center`}`}
        >
          {icon && <ImageComponent className="h-12 w-12" value={icon} />}
          <div
            className={`${icon && `pl-5`} relative flex h-full w-full flex-col ${showDescriptionOnHover && `justify-center`}`}
          >
            <h4
              className={`font-semibold text-green-950 transition-all duration-700 ease-in-out transform ${showDescriptionOnHover ? `text-3xl md:text-3xl group-hover:text-lg group-hover:md:text-xl group-hover:translate-y-[-150%]` : `text-lg md:text-xl`}`}
            >
              {title}
            </h4>
            <p
              className={`top-1/2 left-0 w-full text-regular text-sm md:text-base text-green-900  ${showDescriptionOnHover && `absolute opacity-0 invisible transition-all duration-700 ease-in-out group-hover:opacity-100 group-hover:visible group-hover:translate-y-[-30%]`}`}
            >
              {description?.slice(0, 199)}
              {description?.length > 200 && <span>...</span>}
            </p>
          </div>
          <span className="absolute right-6 duration-300 ease-in-out group-hover:right-4">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-900 text-green-50">
              <svg
                width="11"
                height="10"
                viewBox="0 0 11 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.07704 9.87046L5.31141 9.11477L8.4634 5.96279H0.300049V4.86903H8.4634L5.31141 1.72699L6.07704 0.961365L10.5316 5.41591L6.07704 9.87046Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </span>
        </Link>
      ) : (
        <span>Link text</span> // or nothing
      )}
    </>
  )
}
